// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = "https://dkivveolfhlfmuhmgkur.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRraXZ2ZW9sZmhsZm11aG1na3VyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU4NzQ1NDgsImV4cCI6MjA5MTQ1MDU0OH0.n2qan8QEXm6L5_OLvxKpM432vJoeOEt9gBzGdnMvqT8";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);